import React, { useState } from 'react';
import './Contact.css';

function Contact() {
  const [formData, setFormData] = useState({ email: '', name: '', message: '' });
  const [status, setStatus] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleChange = (e) =>
    setFormData({ ...formData, [e.target.name]: e.target.value });

  const isValidEmail = (email) =>
    /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const { email, name, message } = formData;
    if (!email || !name || !message || !isValidEmail(email)) {
      setStatus('Please fill out all fields with a valid email.');
      return;
    }

    setLoading(true);
    const payload = new FormData();
    payload.append('email', email);
    payload.append('name', name);
    payload.append('message', message);
    payload.append('_captcha', 'false');

    try {
      await fetch('https://formsubmit.co/brockston.king@gmail.com', {
        method: 'POST',
        body: payload,
      });
      setStatus('Message sent successfully! ✅');
      setFormData({ email: '', name: '', message: '' });
    } catch {
      setStatus('Something went wrong. Please try again.');
    }
    setLoading(false);
  };

  return (
    <section className="page">
      <h1>Contact Us</h1>
      <form className="contact-form" onSubmit={handleSubmit}>
        <input
          type="email"
          name="email"
          placeholder="Email"
          value={formData.email}
          onChange={handleChange}
          required
          style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
        />
        <input
          type="text"
          name="name"
          placeholder="Name"
          value={formData.name}
          onChange={handleChange}
          required
          style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
        />
        <textarea
          name="message"
          placeholder="Your message"
          value={formData.message}
          onChange={handleChange}
          required
          style={{ fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif" }}
        />
        <button type="submit" disabled={loading}>
          {loading ? 'Sending...' : 'Send'}
        </button>
        {status && <p>{status}</p>}
      </form>
    </section>
  );
}

export default Contact;
